import Oidc     from './oidc';
import Session  from './session';

export class AuthManager {
    constructor(config) {
        this.clearSession = this.clearSession.bind(this);
        this.logout = this.logout.bind(this);
        Oidc.configureUserManager(config);
        const session = Session.get();
        if (session.authState && session.user) {
            this.session = session;
            this.userManager = Oidc.UserManager;
            this.clearSession();
            console.log("silent renew triggered");
            AuthManager.setupSilentRenew(Oidc.UserManager, Session);
        } else if (window.location.href.includes("authorization_correlation_id")) {
            AuthManager.login(Oidc.UserManager, Session, window.location.search, config['ADMIN_URL'], config['HOME_URL']);
        } else {
            sessionStorage.setItem("requested_url_to_load", window.location.href);
            AuthManager.authenticate(Oidc.UserManager, config['HOME_URL']);
        }
    }

    clearSession() {
        // Terminate Session
        Session.destroy();
    }

    logout() {
        this.clearSession();

        // Logout User & Destroy Session cookie
        if (this.session && this.session.authState) {
            this.userManager.signoutRedirect({ state: this.session.authState }).catch(err => console.log(err));
        }
    }

    static authenticate(oidcUserManager, homeURL) {
        oidcUserManager.clearStaleState()
            .then(function() {
                oidcUserManager.signinRedirect({ redirect_uri: homeURL }).catch(err => console.log(err));
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    static login(oidcUserManager, session, hash, adminURL, homeURL) {       // #state=19d74f05009e4300a86806220ea539d0&id_token=eyJ0eX...
       // const hashes    = hash.slice(7).split('&', 2);                      // hashes = ['19d74f05009e4300a86806220ea539d0', 'eyJ0eX...']
        let authState ;//= "19d74f05009e4300a86806220ea539d0";                 // authState = 19d74f05009e4300a86806220ea539d0
        let parts = hash.substring(1).split('&');
        for (let i = 0; i < parts.length; i++) {
            var nv = parts[i].split('=');
            if (nv[0] == 'state'){
                 authState = nv[1];
            } 
        }
        oidcUserManager.signinRedirectCallback().then(function(user) {
            if (user) {
                // Log User in and redirect Home `/`
                session.set(user.id_token, user.profile, authState, user.access_token);
                location.href = sessionStorage.getItem("requested_url_to_load");
            } else {
                // User logged in (via Central Auth) but doesn't have required permissions to view Application
                location.href = adminURL;
            }
        });
    }

    static setupSilentRenew(oidcUserManager, session) {
        // Set Silent Renew Event Handler (fires when `access_token` about to expire)
          oidcUserManager.events.addAccessTokenExpiring(function() {
            // Start Silent Renew of token (updating the Session Cookie with new `access_token` from Admin / Central Auth)
            oidcUserManager.signinSilent({ state: session.authState }).then(function(user) {
                session.update(user.id_token, user.profile, session.authState, user.access_token);
            });
        });
    }
}